module.exports = __webpack_public_path__ + "media/newstyle/images/icon-camera-7b295d634fdb6a72d2f614321ae8ed75.svg";